import type { PayloadAction } from "@reduxjs/toolkit";
import * as rtk from "@reduxjs/toolkit";

import {
  ExperienceAnalysisReducer,
  ExperienceAnalysisReducerAction,
} from "../reducers/experience-analysis";
import {
  ScreenshotRecommendationReducer,
  ScreenshotRecommendationReducerAction,
} from "../reducers/screenshot-recommendations";
import { IAiState } from "../types/ai";

export const AiAssistants = {
  summary: "asst_WmiybIwGMXi13V2AaMGghkh4",
  custom: "asst_aIgiixhKc5eR30MP4SBfnr8j",
};
export const initialAiState: IAiState = {
  screenshotRecommendations: {
    pendingUrl: null,
    isCustomUrl: false,
    finalUrl: null,
    screenshotUrl: null,
    step: "start",
    recommendationHistory: [],
    latestRecommendations: [],
    showLatest: true,
    resultIndex: 0,
  },
  experienceAnalysis: {
    createdAt: null,
    viewPreviousThreads: false,
    assistantId: AiAssistants.summary,
    autoScroll: true,
    queryTemplate: null,
    query: "",
    isReadyForQuery: false,
    isHidden: true,
    step: "start",
    experience: null,
    threadId: "new",
    dataProgress: 0,
    messages: [],
    isMessageComplete: false,
  },
};

const slice = rtk.createSlice({
  name: "ai",
  initialState: initialAiState,
  reducers: {
    dispatchScreenshotRecommendations: (
      draft,
      action: PayloadAction<ScreenshotRecommendationReducerAction>
    ) => {
      draft.screenshotRecommendations = ScreenshotRecommendationReducer(
        draft.screenshotRecommendations,
        action.payload
      );
    },
    dispatchExperienceAnalysis: (
      draft,
      action: PayloadAction<ExperienceAnalysisReducerAction>
    ) => {
      draft.experienceAnalysis = ExperienceAnalysisReducer(
        draft.experienceAnalysis,
        action.payload
      );
    },
  },
  selectors: {
    aiScreenshotRecommendations: (state) => state.screenshotRecommendations,
    experienceAnalysis: (state) => state.experienceAnalysis,
  },
});

export const { dispatchScreenshotRecommendations, dispatchExperienceAnalysis } =
  slice.actions;

export const { aiScreenshotRecommendations, experienceAnalysis } =
  slice.selectors;

export const aiReducer = slice.reducer;
